import { motion } from "framer-motion";
import { Reveal } from "../../lib/motion";
import { IMAGES } from "../../lib/siteData";

export const DigitalEstate = () => {
  return (
    <section id="digital-estate" data-testid="digital-estate-section" className="relative py-28 lg:py-40 bg-es-surface">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-6">
            <Reveal>
              <p className="text-[11px] uppercase tracking-[0.4em] text-es-accent mb-6">
                The emerging digital estate
              </p>
              <h2 className="font-serif font-light text-es-fg tracking-tight leading-[1.02] text-[clamp(2rem,4.6vw,3.8rem)] max-w-2xl text-balance">
                Your identity is becoming part of what you leave behind.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-8 text-es-muted-fg text-base sm:text-lg leading-relaxed max-w-xl">
                A person's estate may soon include more than property, finances, and
                possessions. Voice recordings, likeness, private messages, memories,
                creative work, values, and personal AI are becoming a new class of digital
                legacy.
              </p>
              <p className="mt-6 text-es-muted-fg text-base sm:text-lg leading-relaxed max-w-xl">
                EverSoul gives individuals a way to define how those materials may be
                preserved, who may access them, whether they may be used to create an
                interactive presence, and what must remain permanently private.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-10 font-serif italic text-es-fg text-xl sm:text-2xl leading-snug max-w-lg">
                The technology may continue. The person's authority should continue with it.
              </p>
            </Reveal>
          </div>

          <Reveal delay={0.1} className="lg:col-span-6">
            <div className="relative overflow-hidden rounded-sm h-[46vh] lg:h-[62vh]">
              <img
                src={IMAGES.digitalEstate}
                alt="Fragments of a life — handwriting, voice, photographs and light — gathering into a protected field"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <motion.img
                src={IMAGES.digitalEstateClean}
                alt="Fragments of a life — handwriting, voice, photographs and light — gathering into a protected field"
                initial={{ opacity: 0 }}
                whileInView={{ opacity: 1 }}
                viewport={{ once: false, amount: 0.35 }}
                transition={{ duration: 5, ease: "easeInOut" }}
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="pointer-events-none absolute inset-0 ring-1 ring-inset ring-es-border" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
